import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a88d056c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M17.51 3.87001L15.73 2.10001L5.83997 12L15.74 21.9L17.51 20.13L9.37997 12L17.51 3.87001Z",
    fill: "black",
    "fill-opacity": "0.54"
  })
], -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6.48999 20.13L8.25999 21.9L18.16 12L8.25999 2.10001L6.48999 3.87001L14.62 12L6.48999 20.13Z",
    fill: "black",
    "fill-opacity": "0.54"
  })
], -1))
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "pagination",
    style: _normalizeStyle({ justifyContent: _ctx.justifyContent, height: _ctx.pagHeight })
  }, [
    _createElementVNode("button", {
      class: _normalizeClass([
        'pagination__button-previous',
        { disabled: _ctx.isPreviousDisabled },
        _ctx.buttonRoundedClass
      ]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.previousPage && _ctx.previousPage(...args)))
    }, _hoisted_2, 2),
    _createElementVNode("ul", {
      class: _normalizeClass(["pagination__item", [{ 'with-bg': _ctx.hasBackground }, _ctx.roundedClass]])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (page, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: index,
          onClick: ($event: any) => (_ctx.skip(page)),
          style: _normalizeStyle(_ctx.itemStyle),
          class: _normalizeClass({
          active: _ctx.isCurrentPage(page),
          interactive: _ctx.isNotEllipsis(page)
        })
        }, _toDisplayString(_ctx.setPageLink(page)), 15, _hoisted_3))
      }), 128))
    ], 2),
    _createElementVNode("button", {
      class: _normalizeClass([
        'pagination__button-next',
        { disabled: _ctx.isNextDisabled },
        _ctx.buttonRoundedClass
      ]),
      disabled: _ctx.isNextDisabled,
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
    }, _hoisted_6, 10, _hoisted_4)
  ], 4))
}